import { Scope } from '@toeverything/infra';

// import type { Editor } from '../entities/editor';

export class EditorScope<Editor> extends Scope<{
  editor: Editor;
}> {}
